import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { YearProvider } from "./admin/components/YearContext";

// Loader
import Loader from "./landing/components/Loader";

// Components
import Forgetpassword from "./components/forgetpassword";

// Landing Pages
import Home from "./landing/pages/Home";
import ContactUs from "./landing/pages/Contactus";
import PricesSection from "./landing/pages/PricesSection";
import AboutusHome from "./landing/pages/AboutusHome";
import Refundstatus from "./landing/pages/Refundstatus";
import Upperbox from "./landing/pages/Upperbox";
import ReferAndEarn from "./landing/pages/Referandearn";
import Staterefundstatus from "./landing/pages/Staterefundstatus";
import Terms from "./landing/pages/Terms";
import Refundpolicy from "./landing/pages/Refundpolicy";
import Privacypolicy from "./landing/pages/Privacypolicy";
import Whatsapp from "./landing/components/Whatsapp";
import Federal from "./landing/pages/federal";
import Amendment from "./landing/pages/amendment";
import Itinpreparation from "./landing/pages/itinpreparation";
import Fbar from "./landing/pages/fbar";
import W4assistance from "./landing/pages/w4assistance";
import Taxextension from "./landing/pages/taxextension";
import Estimatetax from "./landing/pages/estimatetax";
import Taxplanning from "./landing/pages/taxplanning";
import Filingoptions from "./landing/pages/filingoptions";
import Representation from "./landing/pages/representation";
import Services from "./landing/pages/Services";
import Error404 from "./landing/components/Error404";
import International from "./landing/pages/international";
import Payroll from "./landing/pages/payroll";
import Business from "./landing/pages/business";
import Businessreturns from "./landing/pages/businessreturns";
import Bookkeeping from "./landing/pages/Bookkeeping";
import Boir from "./landing/pages/boir";

// Authentication
import Signup from "./landing/components/signup";
import Loginn from "./landing/components/loginn";

// Admin Pages
import Admindashboard from "./admin/pages/Admindashboard";
import Adminanalytics from "./admin/pages/Adminanalytics";
import Adminclients from "./admin/pages/Adminclients";
import Adminleads from "./admin/pages/Adminleads";
import Employeestatus from "./admin/pages/Employeestatus";
import Admindocuments from "./admin/pages/Admindocuments";
import Adminemployees from "./admin/pages/Employeeinfo";
import Admininvoice from "./admin/pages/Admininvoice";
import Adminpayments from "./admin/pages/Adminpayments";
import Searchclient from "./admin/pages/SearchClient";
import Adminprofile from "./admin/pages/Adminprofile";
import Adminsettings from "./admin/pages/Adminsettings";
import Clientviewdocs from "./admin/pages/Clientviewdocs";
import EditEmployee from "./admin/pages/EditEmployee";

// Employee Pages
import Empdashboard from "./employee/pages/Empdashboard";
import Empprofile from "./employee/pages/Empprofile";
import Empshifts from "./employee/pages/Empshifts";
import Empleads from "./employee/pages/Empleads";
import Empinvoice from "./employee/pages/Empinvoice";
import Empclients from "./employee/pages/Empclients";
import Empdocuments from "./employee/pages/Empdocuments";
import Empsettings from "./employee/pages/Empsettings";
import Empclientviewdocs from "./employee/pages/Empclientviewdocs";
import Empsearchclient from "./employee/pages/Empsearchclient";
import Emppayments from "./employee/pages/Emppayments";

// Client Pages
import Clientdashboard from "./client/pages/Clientdashboard";
import Clienttaxorganizer from "./client/pages/Taxorganizer";
import Clientdocuments from "./client/pages/Clientdocuments";
import Clientreferandearn from "./client/pages/Referandearn";
import Clientinvoices from "./client/pages/Clientinvoices";
import Clientprofile from "./client/pages/Clientprofile";
import Clientsettings from "./client/pages/Clientsettings";
import Clienthelpcenter from "./client/pages/Helpcenter";

function App() {
  return (
    <YearProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" />
        <React.Suspense
          fallback={
            <div className="loader-container">
              <Loader />
            </div>
          }
        >
          <Routes>
            {/* Public Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutusHome />} />
            <Route path="*" element={<Error404 />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/price" element={<PricesSection />} />
            <Route path="/refundstatus" element={<Refundstatus />} />
            <Route path="/staterefundstatus" element={<Staterefundstatus />} />
            <Route path="/upperbox" element={<Upperbox />} />
            <Route path="/referandearn" element={<ReferAndEarn />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refundpolicy" element={<Refundpolicy />} />
            <Route path="/privacypolicy" element={<Privacypolicy />} />
            <Route path="/whatsapp" element={<Whatsapp />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/federal" element={<Federal />} />
            <Route path="/amendment" element={<Amendment />} />
            <Route path="/itinpreparation" element={<Itinpreparation />} />
            <Route path="/fbar" element={<Fbar />} />
            <Route path="/w4assistance" element={<W4assistance />} />
            <Route path="/taxextension" element={<Taxextension />} />
            <Route path="/estimatetax" element={<Estimatetax />} />
            <Route path="/taxplanning" element={<Taxplanning />} />
            <Route path="/filingoptions" element={<Filingoptions />} />
            <Route path="/representation" element={<Representation />} />
            <Route path="/bookkeeping" element={<Bookkeeping />} />
            <Route path="/business" element={<Business />} />
            <Route path="/businessreturns" element={<Businessreturns />} />
            <Route path="/international" element={<International />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/boir" element={<Boir />} />

            {/* Authentication */}
            <Route path="/login" element={<Loginn />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgetpassword" element={<Forgetpassword />} />

            {/* Admin Pages */}
            <Route path="/admin" element={<Admindashboard />} />
            <Route path="/adminanalytics" element={<Adminanalytics />} />
            <Route path="/clients" element={<Adminclients />} />
            <Route path="/leads" element={<Adminleads />} />
            <Route path="/employeestatus" element={<Employeestatus />} />
            <Route path="/documentstimeline" element={<Admindocuments />} />
            <Route path="/employeinformation" element={<Adminemployees />} />
            <Route path="/searchclient" element={<Searchclient />} />
            <Route path="/invoice" element={<Admininvoice />} />
            <Route path="/payments" element={<Adminpayments />} />
            <Route path="/adminprofile" element={<Adminprofile />} />
            <Route path="/adminsettings" element={<Adminsettings />} />
            <Route path="/viewclientdocs" element={<Clientviewdocs />} />
            <Route path="/edit-employee/:empId" element={<EditEmployee />} />

            {/* Employee Pages */}
            <Route path="/employee" element={<Empdashboard />} />
            <Route path="/empProfile" element={<Empprofile />} />
            <Route path="/empshifts" element={<Empshifts />} />
            <Route path="/empLeads" element={<Empleads />} />
            <Route path="/empClients" element={<Empclients />} />
            <Route path="/empdocuments" element={<Empdocuments />} />
            <Route path="/empinvoices" element={<Empinvoice />} />
            <Route path="/empsettings" element={<Empsettings />} />
            <Route path="/empclientviewdocs" element={<Empclientviewdocs />} />
            <Route path="/empsearchclient" element={<Empsearchclient />} />
            <Route path="/emppayments" element={<Emppayments />} />

            {/* Client Pages */}
            <Route path="/client" element={<Clientdashboard />} />
            <Route path="/taxorganizer" element={<Clienttaxorganizer />} />
            <Route path="/documents" element={<Clientdocuments />} />
            <Route path="/clientreferandearn" element={<Clientreferandearn />} />
            <Route path="/clientinvoices" element={<Clientinvoices />} />
            <Route path="/clientprofile" element={<Clientprofile />} />
            <Route path="/settings" element={<Clientsettings />} />
            <Route path="/helpcenter" element={<Clienthelpcenter />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </YearProvider>
  );
}

export default App;
